import axios from 'axios';
import { URL } from '../../redux/Url';

// Function to get the authorization token
const getAuthToken = () => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  return userInfo.token ? `Bearer ${userInfo.token}` : null;
};

// Create and export an Axios instance
const axiosInstance = axios.create({
  baseURL: `${URL}/api`,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Use Axios interceptors to append the Authorization header
axiosInstance.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers['Authorization'] = token;
  }
  return config;
});

export default axiosInstance;